import axios, { AxiosResponse } from 'axios';

import IAddress from '../models/IAddress';

type AxiosContinuationResponseData<T> = {
	items: T[];
	continuationToken?: string;
};

type SearchParams = {
	pageSize: number;
	continuationToken?: string;
};

export default class AddressLookupService
{
	public searchAddresses(searchQuery: string, params: SearchParams = {
		pageSize: 10
	}): Promise<AxiosContinuationResponseData<IAddress>>
	{


		const url = `${window.__appSettings.apiEndpoints.addressApi}`;

		return axios.post<AxiosContinuationResponseData<IAddress>>(url, {
			searchText: searchQuery,
			pageSize: params?.pageSize ?? 10,
			continuationToken: params?.continuationToken
		})
			.then(response =>
			{
				this.checkResponse(url, response);
				return {
					items: response.data.items,
					continuationToken: response.data.continuationToken
				};
			});
	}

	public getAddressById(addressId: string): Promise<IAddress>
	{
		const url = `${window.__appSettings.apiEndpoints.addressApi}/${addressId}`;

		return axios.get<IAddress>(url)
			.then(response =>
			{
				this.checkResponse(url, response);
				return response.data;
			});
	}

	private checkResponse<T>(url: string, response: AxiosResponse<T>): boolean
	{
		if (response.status >= 200 && response.status <= 299)
		{
			console.info(`Call to ${url} was successful`);
			return true;
		}

		throw new Error(`Failed to call ${url} (Status: ${response.status})`);
	}
}
